var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 d-flex flex-column mb-3" }, [
    _c("div", { staticStyle: { flex: "1", "margin-left": "45px" } }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [_c("section-title", { attrs: { title: _vm.label } })],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-1" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "form-row" }, [
          _c(
            "div",
            {
              staticClass: "mb-2",
              class: { "col-md-9": !_vm.disabled, "col-md-8": _vm.disabled },
              staticStyle: { height: "38px" }
            },
            [
              _c("div", { staticClass: "d-flex" }, [
                _c("div", { staticStyle: { width: "45px" } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row", staticStyle: { flex: "1" } },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v(
                                _vm._s(_vm.$t("apps.inventory.message.bin"))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("BaseDropdown", {
                            attrs: {
                              options: _vm.binOptions,
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.value.binId,
                              callback: function($$v) {
                                _vm.$set(_vm.value, "binId", $$v)
                              },
                              expression: "value.binId"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-491b6945", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-491b6945","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseGTPutAwaySerial.vue
// module id = null
// module chunks = 